import CrossIcon from "@assets/icons/common/cross_icon.svg?react";
interface ModalHeaderTypes {
  title: string;
  subTitle: string;
  icon?: React.ReactElement;
  onClose?: (value: boolean) => void;
}

const ModalHeader: React.FC<ModalHeaderTypes> = ({
  title,
  subTitle,
  icon,
  onClose,
}) => {
  return (
    <div className="h-[80px] border-b border-neutral-200">
      <div className="p-4">
        <div className="flex items-center justify-between">
          <div className="flex gap-[10px] items-center">
            {icon && icon}
            <div className="flex-col flex">
              <span className="font-medium">{title}</span>
              <span className="mt-[2px] font-normal text-[12px] text-[#475467]">
                {subTitle}
              </span>
            </div>
          </div>
          {onClose && (
            <button
              onClick={() => onClose(false)}
              className="ml-4 p-2 bg-transparent border-none cursor-pointer"
            >
              <CrossIcon height={20} />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModalHeader;
